
import {merge as observableMerge, fromEvent as observableFromEvent,  BehaviorSubject ,  Observable } from 'rxjs';

import {map, debounceTime, distinctUntilChanged} from 'rxjs/operators';
import { PacketDetails } from './../../shared/configuration.model';
import { ConfigurationService } from './../../shared/configuration.service';
import { AuthenticationService } from './../../shared/authentication.service';
import { Component, ElementRef, ViewChild, OnInit, forwardRef, ChangeDetectorRef } from '@angular/core';
import { DataSource } from '@angular/cdk/collections';
import { MatPaginator, MatSort, MatDialog, ErrorStateMatcher } from '@angular/material';
import { MatSnackBar } from  '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';






import { DatePipe } from '@angular/common'
import { TicketService } from '../../shared/ticketService';
import { QualityGroupUsers } from '../../shared/qaTicket';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return !!(control && control.invalid && (control.dirty || control.touched));
  }
}


@Component({
  selector: "app-viewusersbyqualitygroup",
  templateUrl: "./viewusersbyqualitygroup.component.html",
  styleUrls: ["./viewusersbyqualitygroup.component.scss"]
})

export class ViewusersbyqualitygroupComponent implements OnInit {
  screen = false;
  property: string = '';
  QualityGroups = new Array<PacketDetails>();
  ActiveQualityGroups = new Array<PacketDetails>();
  isDataAvailable = false;
  displayedColumns = ['qualitygroupuser', 'qualitygroup'];
  dataChange: BehaviorSubject<QualityGroupUsers[]> = new BehaviorSubject<QualityGroupUsers[]>([]);
  get data(): QualityGroupUsers[] { return this.dataChange.value; }
  dataSource: ConfigurationDataSource | null;
  public errormessage: string | null;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('filter') filter: ElementRef;

  updateLockRow: QualityGroupUsers[] = [];

  constructor(
    private configurationService: ConfigurationService,
    public dialog: MatDialog,
    private cdRef: ChangeDetectorRef,
    private auth: AuthenticationService,
    public router: Router,
    public route: ActivatedRoute,
    public snackBar: MatSnackBar,
    public ticketService: TicketService,
    public datepipe: DatePipe) {
  }

  qualityGroupSelect = new FormControl('', [Validators.required]);

  matcher = new MyErrorStateMatcher();

  populateConfigurationQueue() {
    this.screen = true;
    this.ticketService.getUsersByQualityGroup(this.auth.token, this.property, this.auth.currentState).subscribe(rcgitems => {
      
      if(rcgitems !== null) {
      this.dataChange.next(rcgitems);
      this.isDataAvailable = true;
      this.cdRef.detectChanges();
      this.initSource();
      this.screen = false;
     }
    });
  }


  ngOnInit() {
      this.configurationService.getPackages(this.auth.currentState).subscribe(data => {
        this.QualityGroups = data;
        this.QualityGroups.forEach(element => {
          if(element.IsActive && element.Name !== 'Default') {
            this.ActiveQualityGroups.push(element);
          }
      });
    });
  }

  initSource() {
    this.dataSource = new ConfigurationDataSource(this, this.paginator, this.sort);
    observableFromEvent(this.filter.nativeElement, 'keyup').pipe(
      debounceTime(150),
      distinctUntilChanged(),)
      .subscribe(() => {
        if (!this.dataSource) { return; }
        this.dataSource.filter = this.filter.nativeElement.value;
      });
    this.cdRef.detectChanges();
  }

  searchClick() {
    
    if(this.property === ''){
      this.qualityGroupSelect.invalid;
      this.qualityGroupSelect.markAsDirty();
      this.errormessage = "This field is required";
      return;
    }else{
    this.populateConfigurationQueue();
    }
  }
}


export class ConfigurationDataSource extends DataSource<any> {
  _filterChange = new BehaviorSubject('');
  get filter(): string { return this._filterChange.value; }
  set filter(filter: string) { this._filterChange.next(filter); }

  dataChange: BehaviorSubject<QualityGroupUsers[]> = new BehaviorSubject<QualityGroupUsers[]>([]);
  get data(): QualityGroupUsers[] { return this.dataChange.value; }

  filteredData: QualityGroupUsers[] = [];
  renderedData: QualityGroupUsers[] = [];

  constructor(private rcgcomponent: ViewusersbyqualitygroupComponent,
    private _paginator: MatPaginator,
    private _sort: MatSort) {
    super();

    this._filterChange.subscribe(() => this._paginator.pageIndex = 0);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<QualityGroupUsers[]> {
    // Listen for any changes in the base data, sorting, filtering, or pagination
    const displayDataChanges = [
      this.rcgcomponent.dataChange,
      this._sort.sortChange,
      this._filterChange,
      this._paginator.page,
    ];

    return observableMerge(...displayDataChanges).pipe(map(() => {
      // Filter data
      
      this.filteredData = this.rcgcomponent.data.slice().filter((item: QualityGroupUsers) => {
        const searchStr = (item.Username).toLowerCase();
        return searchStr.indexOf(this.filter.toLowerCase()) !== -1;
      });
    

      // Sort filtered data
      const sortedData = this.sortData(this.filteredData.slice());

      // Grab the page's slice of the filtered sorted data.
      const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
      this.renderedData = sortedData.splice(startIndex, this._paginator.pageSize);
      return this.renderedData;
    
    }));
  
  }

  disconnect() { }

  /** Returns a sorted copy of the database data. */
  sortData(data: QualityGroupUsers[]): QualityGroupUsers[] {
    if (!this._sort.active || this._sort.direction === '') { return data; }

    return data.sort((a, b) => {
      let propertyA: number | string = '';
      let propertyB: number | string = '';

      switch (this._sort.active) {
        case 'qualitygroupuser': [propertyA, propertyB] = [a.Username, b.Username]; break;
      }

      const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
      const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

      return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
    });
  }
}